import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { HelmetProvider } from "react-helmet-async";
import SEO from "@/components/seo/SEO";
import RichSchemas from "@/components/seo/RichSchemas";
import { EditModeProvider } from "@/components/editor/EditModeContext";
import EditModeToggle from "@/components/editor/EditModeToggle";
import Navigation from "@/components/sections/Navigation";
import Footer from "@/components/sections/Footer";
import HomePage from "@/components/pages/HomePage";
import StoryPage from "@/components/pages/StoryPage";
import LandPage from "@/components/pages/LandPage";
import EnvironmentPage from "@/components/pages/EnvironmentPage";
import OffGridPage from "@/components/pages/OffGridPage";
import GalleryPage from "@/components/sections/GalleryPage";
import FAQPage from "@/components/pages/FAQPage";
import GuestBookPage from "@/components/pages/GuestBookPage";
import ActivitiesPage from "@/components/pages/ActivitiesPage";
import BookingPage from "@/components/pages/BookingPage";
import WaitlistPage from "@/components/pages/WaitlistPage";
import VideosPage from "@/components/pages/VideosPage";
import WhalesPage from "@/components/pages/WhalesPage";
import AdminPage from "@/components/admin/AdminPage";

function ScrollToHash() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      setTimeout(() => {
        const el = document.querySelector(hash);
        if (el) el.scrollIntoView({ behavior: "smooth" });
      }, 100);
    } else {
      window.scrollTo(0, 0);
    }
  }, [pathname, hash]);
  return null;
}

function Layout({ children, dark }) {
  return (
    <EditModeProvider>
      <SEO />
      <RichSchemas />
      <div className={`min-h-screen ${dark ? "bg-[#2C3828]" : "bg-wc-cream"}`}>
        <Navigation />
        {children}
        {!dark && <Footer />}
        <EditModeToggle />
      </div>
    </EditModeProvider>
  );
}

function GalleryLayout() {
  return (
    <EditModeProvider>
      <SEO />
      <RichSchemas />
      <div className="min-h-screen bg-wc-cream">
        <Navigation />
        <GalleryPage />
        <Footer />
        <EditModeToggle />
      </div>
    </EditModeProvider>
  );
}

function EnvironmentLayout() {
  return (
    <EditModeProvider>
      <SEO />
      <RichSchemas />
      <div className="min-h-screen bg-[#2C3828]">
        <Navigation />
        <EnvironmentPage />
        <EditModeToggle />
      </div>
    </EditModeProvider>
  );
}

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <ScrollToHash />
        <Routes>
          <Route path="/admin" element={<><SEO /><AdminPage /></>} />
          <Route path="/gallery" element={<GalleryLayout />} />
          <Route path="/environment" element={<EnvironmentLayout />} />
          <Route path="/story" element={<Layout><StoryPage /></Layout>} />
          <Route path="/land" element={<Layout><LandPage /></Layout>} />
          <Route path="/offgrid" element={<Layout><OffGridPage /></Layout>} />
          <Route path="/faq" element={<Layout><FAQPage /></Layout>} />
          <Route path="/guestbook" element={<Layout><GuestBookPage /></Layout>} />
          <Route path="/activities" element={<Layout><ActivitiesPage /></Layout>} />
          <Route path="/booking" element={<Layout><BookingPage /></Layout>} />
          <Route path="/waitlist" element={<Layout><WaitlistPage /></Layout>} />
          <Route path="/videos" element={<Layout><VideosPage /></Layout>} />
          <Route path="/whales" element={<Layout><WhalesPage /></Layout>} />
          <Route path="*" element={<Layout><HomePage /></Layout>} />
        </Routes>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
